import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TrialService {
  isTrialMode: boolean = false;
  trialsAvailable: number;
  timeTrialExpiration: number;
  hasRequestedTrialMode: boolean;
  hasTrialExpired: boolean;
  shouldEnableRequestTrial: boolean;
  hasClickedOnEmailLink: boolean;
  hasTimeDuration: boolean;
}
